export const optionsForUserStatus: Array<string> = ['active', 'blocked'];

export const ARCHIVED_USER_STATUS = 'archived';

export const optionsForArchivedUserStatus: Array<string> = [
  ...optionsForUserStatus,
  ARCHIVED_USER_STATUS,
];

export const optionsForCWStatus: Array<string> = ['open', 'verified', 'failed'];

export const optionsForManualApproval: Array<string> = [
  'open',
  'verified',
  'failed',
];

export const optionsForCardStatus: Array<string> = [
  'open',
  'listed',
  'verified',
  'paused',
  'deleted',
];

export const optionsForUserType: Array<string> = ['user', 'org', 'solopreneur'];

export const optionsForBlockReason: Array<string> = [
  'fraud',
  'duplicate',
  'spam',
  'other',
];

export const optionsForBlockReasonDetails: Array<string> = [
  'duplicateLicense',
  'duplicateIdentityDocument',
  'duplicateUserIdentity',
  'fraudLicense',
  'fraudIdentity',
  'fraudPayment',
  'fraudOther',
  'creditCheck',
  'watchlisted',
  'poorDriver',
  'poorDebtor',
];
